<template>
  <b-card-code title="جدول المحاضرات المرفوعة" no-body>
    <b-card-body>
      <div class="d-flex justify-content-between flex-wrap">

        <b-form-group
          label="فلتر"
          label-cols-sm="2"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="ابحث عن .."
            />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                الغاء الفلتر
              </b-button>
              <b-button v-if="role"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                v-b-modal.model-a-w
              >
                <feather-icon icon="FilePlusIcon" class="mr-50" />
                <span class="align-middle">اضافة محاضرة جديدة</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
    </b-card-body>
<div class="demo-vertical-spacing">
      <b-progress
      v-if="precentage !== 0"
        :value="precentage"
        max="100"
      />
      </div>
    <b-table
      striped
      hover
      responsive
      class="position-relative"
      :per-page="perPage"
      :current-page="currentPage"
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :filter="filter"
      :filter-included-fields="filterOn"
      @filtered="onFiltered"
    >
      <template #cell(action)="action">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-col md="12">
            <b-button v-if="canEdit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-warning"
              v-b-modal.model-e-w
              @click="eRM(action.item)"
            >
              <feather-icon icon="EditIcon" class="mr-50" />
              <span class="align-middle">تعديل المحاضرة</span>
            </b-button>
          </b-col>
          <b-col v-if="canDelete" md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              v-b-modal.modal-center
              @click="dRM(action.item)"
            >
              <feather-icon icon="Trash2Icon" class="mr-50" />
              <span class="align-middle">حذف المحاضرة</span>
            </b-button>
          </b-col>
        </b-dropdown>
      </template>
      <template #cell(link)="link">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-info"
          @click="view(link.item.file)"
        >
          <feather-icon icon="FileTextIcon" class="mr-50" />
          <span class="align-middle">عرض المحاضرة</span>
        </b-button>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>

      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
        class="mb-0"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </b-card-body>
    <b-modal
      id="model-e-w"
      ok-title="تعديل البيانات"
      centered
      size="lg"
      title="تعديل المحاضرة"
      @show="checkModel"
      @ok="uM"
      @hidden="rEF"
    >
      <b-form novalidate class="needs-validation">
        <b-form-row>
          <b-col md="12">
            <label for="input-valid1">عنوان المحاضرة:</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.name"
              :state="editform.name.length > 0"
              placeholder="عنوان المحاضرة"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">اختر الملف (pdf.):</label>
            <b-form-file
              placeholder="اختر الملف او اسقطها هنا..."
              drop-placeholder="اختر الملف او اسقطها هنا..."
              v-model="editform.files"
               @change="selectFile"
            />
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
    <b-modal
      id="model-a-w"
      ok-title="حفظ البيانات"
      centered
      size="lg"
      title="اضافة محاضرة جديدة"
      @show="checkModel"
      @ok="aNM"
      @hidden="rF"
    >
      <b-form novalidate class="needs-validation">
          <b-form-row>
            <b-col md="12">
              <label for="input-valid1">اختر المحاضرات (يمكنك اختيار اكثر من ملف pdf.):</label>
              <b-form-file
                placeholder="اختر الملف او اسقطها هنا..."
                drop-placeholder="اختر الملف او اسقطها هنا..."
                multiple
                ref="file"
                v-model="form.files"
                @change="selectFiles"
              />
            </b-col>
          </b-form-row>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-center"
      centered
      title="Delete file"
      @ok="dM"
      ok-title="Accept"
    >
      <b-card-text>
        هل تريد حذف هذه الحقل " {{ this.editform.name }} " ?
      </b-card-text>
    </b-modal>
  </b-card-code>
</template>

<script>
import vSelect from "vue-select";
import store from "@/store";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BTable,
  BAvatar,
  BModal,
  BDropdown,
  BDropdownItem,
  BFormCheckboxGroup,
  BForm,
  BFormRow,
  BCol,
  VBModal,
  BBadge,
  BFormValidFeedback,
  BFormInvalidFeedback,
  BFormGroup,
  BFormCheckbox,
  BCardText,
  BFormSelect,
  BPagination,
  BInputGroup,BProgress,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BFormFile,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { integer } from "vee-validate/dist/rules";
import { filesUrl } from "@/main.js";

export default {
  components: {
    BCardCode,
    BTable,
    BForm,BProgress,
    BFormFile,
    vSelect,
    filesUrl,
    BAvatar,
    BBadge,
    BFormRow,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    togglePasswordVisibility,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormCheckboxGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BModal,
    VBModal,
    Ripple,
    BCol,
    BFormCheckbox,
    BCardText,
    BFormValidFeedback,
    BFormInvalidFeedback,
  },
  data() {
    return {
      precentage:0,
      teacher_id: "",
      perPage: 3,
      pageOptions: [3, 5, 10, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      role:null,
      canDelete:null,
      sortDirection: "asc",
      department: "",
      title: "",
      teacherId:"",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      lecture_id: "",
      departments: [],
      teachers: [],
      stages: [],
      fields: [
        {
          key: "name",
          label: "العنوان ",
        },
        {
          key: "link",
          label: "لعرض المحاضرة ",
        },
        { key: "action", label: "الاجراءات" },
      ],
      items: [],
      notifi: {
        route: "",
        title: "",
        item_id: "",
        table: "",
        users: [],
        departments: [],
        role_id: "",
        type: "",
        subtitle: "",
        bg: "",
      },
      form: {
        files: [],
        lecture_id: "",
      },
      editform: {
        name: "",
        files: "",
        lecture_id: "",
        id: null,
      },
      selected: [],
      selected2: [],
    };
  },
  watch:{
"$route.params.id": {
      handler: function (search) {
        this.gR();
      },
    },
  },
  mixins: [togglePasswordVisibility],
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  directives: {
    Ripple,
  },
  mounted() {
    if(localStorage.getItem("NisourRole")=="admin"||localStorage.getItem("NisourRole")=="teacher"){
      this.role = true
    }else{
            this.role = false
    }
    if(localStorage.getItem("NisourRole")=="admin"||localStorage.getItem("NisourRole")=="teacher"){
      this.canDelete = true
      this.canEdit = true
    }else{
      this.canDelete = false
      this.canEdit = false
    }
    this.teacherId = localStorage.getItem("NisourTeacherId");
    this.ID(), this.gR();
    this.totalRows = this.items.length;
  },
  methods: {
    checkModel() {
      this.selected = [];
      if (this.editform.is_sustainabilty == 1) {
        this.selected.push("is_sustainabilty");
      }
      if (this.editform.is_energy == 1) {
        this.selected.push("is_energy");
      }
    },
    async uM() {
      this.form.lecture_id = this.$route.params.id
      let data = new FormData();
      data.append("lecture_id", this.editform.lecture_id);
      data.append("name", this.editform.name);
      data.append("file",this.editform.files)
      await this.axios
        .post(`files/${this.editform.id}`, data,{
          onUploadProgress: progressEvent => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          }
        })
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gR();
            this.makeToast(
              "success",
              "update Success",
              "Your update is done successfully"
            );
            this.notifi.route = "lecture-files-notif";
            this.notifi.title = "update action";
            this.notifi.item_id = res.data.data.lecture_id;
            this.notifi.table = "files";
            this.notifi.role_id = 1;
            this.notifi.type = "light-worning";
            this.notifi.subtitle = "updated a files";
            this.notifi.bg = "bg-worning";
            this.sendNoti();
          }
          this.precentage=0
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
        this.rEF()
    },
    async sendNoti() {
      await this.axios.post(`notifications`, this.notifi);
    },
    async aNM() {
      this.form.lecture_id = this.$route.params.id
      let data = new FormData();
      data.append("lecture_id", this.form.lecture_id);
      this.form.files.forEach(element =>
      data.append("files[]",element)
      ); 
      await this.axios
        .post(`files`, data,{
          onUploadProgress: progressEvent => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          }
        })
        .then((res) => {
          console.log(res);
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gR();
            this.makeToast(
              "success",
              "update Success",
              "Your model is added successfully"
            );
            this.notifi.route = "lecture-files-notif";
            this.notifi.title = "add action";
            this.notifi.item_id = res.data.data.lecture_id;
            this.notifi.table = "files";
            this.notifi.role_id = 1;
            this.notifi.type = "light-Success";
            this.notifi.subtitle = "added a new files";
            this.notifi.bg = "bg-success";
            this.sendNoti();
          }
          this.rF();
          this.precentage=0
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
      this.rF();
    },
    rF() {
      this.form.files = []
    },
    rEF() {
      this.editform.name = "",
      this.editform.file = "",
      this.editform.id = null
    },
    async dM() {
      await this.axios
        .delete(`files/${this.editform.id}`)
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gR();
            this.makeToast(
              "success",
              "Delete Success",
              "Your item is deleted successfully"
            );
             this.notifi.route = "lecture-files-notif";
            this.notifi.title = "delete action";
            this.notifi.item_id = res.data.data.lecture_id;
            this.notifi.table = "files";
            this.notifi.role_id = 1;
            this.notifi.type = "light-danger";
            this.notifi.subtitle = "deleted file";
            this.notifi.bg = "bg-danger";
            this.sendNoti();
          }
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    errorToast() {
      this.makeToast(
        "danger",
        "update failed",
        "some thing want wrong, i`m sorry :("
      );
    },
    eRM(item) {
      this.editform.name = item.name;
      this.editform.lecture_id = this.$route.params.id;
      this.editform.id = item.id;
    },
    dRM(item) {
      this.editform.name = item.full_name;
      this.editform.id = item.id;
    },
    check() {
      setTimeout(() => this.gR(), 1000);
    },
    ID() {
      this.teacher_id = localStorage.getItem("NisourTeacherId");
    },
    async gR() {
      await this.axios
        .get(`lecture/${this.$route.params.id}/files`)
        .then((res) => {
          this.items = [];
          this.totalRows = res.data.items.files_count;
          this.items = res.data.items.files;
          this.lecture_id = res.data.items.id;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "danger",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    makeToast(variant = null, title = null, body = null) {
      this.$bvToast.toast(body, {
        title: title,
        variant,
        solid: false,
      });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    view(path) {
      window.open(`${filesUrl}/${path}`, "_blank");
    },
    selectFiles(e) {
      this.form.files=[]
      this.editForm.files=[]
      console.log(e.target.files)
      console.log(e.target.files[0])
      e.target.files.forEach(element =>
      this.form.files.push(element)
      );
      console.log(this.form.files)
    },
    selectFile(e) {
      this.editform.files=""
      console.log(e.target.files)
      console.log(e.target.files[0])
      this.editform.files = e.target.files[0]
      console.log(this.editform.files)
    },
  },
};
</script>
